
        window.MAP_BOX_ACCESS_TOKEN = import.meta.env.VITE_MAPBOX_PUBLIC_TOKEN
        window.POSTHOG_API_KEY = import.meta.env.VITE_POSTHOG_API_KEY
        window.POSTHOG_API_HOST = import.meta.env.VITE_POSTHOG_API_HOST
    